export default __webpack_public_path__ + "static/media/about-us-banner.580829e4.jfif";